import "core-js/stable";
import "regenerator-runtime/runtime";
import Swiper from "swiper";
// import Swiper styles
import "swiper/css";
import { createApp } from "vue";

// Quote Rotator
const testimonials = async () => {
    // Import our CSS

    // Async load the vue module
    const Vue = await import(/* webpackChunkName: "vue" */ "vue");

    // Create our vue instance
    const testimonialsVue = createApp({
        compilerOptions: { delimiters: ["${", "}"] },
        components: {},
        data: ()=>({
            swipe: null,
        }),
        computed: {},
        methods: {
            init: function () {
                this.swipe = new Swiper(".testimonial-slider__container", {
                    autoHeight: !0, //enable auto height
                    spaceBetween: 0,
                    slidesPerView: 1,

                    slideClass: "testimonial-slide",
                    slideActiveClass: "testimonial-slide--active",
                    wrapperClass: "testimonial-slides",

                    pagination: {
                        el: ".pagidots",
                        clickable: true,
                        bulletClass: "pagidot",
                        bulletActiveClass: "pagidot--active",
                        renderBullet: function (index, className) {
                            //return '<span class="' + className + '">' + (index + 1) + '</span>';
                            return '<li class="' + className + '"><span class=""></span></li>';
                        },
                    },
                });
            },
        },
        mounted() {
            console.log("Testimonials VUE is Ready, ok");
            this.$nextTick(function () {
                this.init();
            });
        },
    });

    return testimonialsVue.mount("#testimonials-rotator");
};
// Execute async function
testimonials()
    .then((value) => {
        console.log("Vue Testimonials component mounted");
    })
    .catch((err) => {
        console.log("Error mounting Vue Testimonials component");
    });

export default testimonials;
